import { ChevronLeftIcon } from './ChevronLeftIcon';

/**
 * author: Google
 * id CF5607F2-4106-4D47-8FE6-B8F5A16E6D98
 * name chevron-left
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chevron-left.svg
 * tags
 * - Arrow 
 */
export const NavigateBeforeIcon = ChevronLeftIcon;
export default NavigateBeforeIcon